import { Injectable } from '@angular/core';

import { HtmlNode, WindowRef } from '@frontend/vanilla/core';
import { TopMenuVisibility } from '@frontend/vanilla/features/navigation-layout';
import { AccountMenuConfig } from '@frontend/vanilla/shared/account-menu';

import { AccountMenuV2ClientConfig, CommonClientConfig } from '../client-config/client-config.models';
import { AccountMenuVersion } from '../common-controls/common-controls.model';

@Injectable({
    providedIn: 'root',
})
export class NewAccountMenuService {
    constructor(
        private accountMenuV2Config: AccountMenuV2ClientConfig,
        private commonClientConfig: CommonClientConfig,
        private htmlNode: HtmlNode,
        private window: WindowRef,
        private accountMenuConfig: AccountMenuConfig,
    ) {}

    hideTopMenu(sourceitem: string): TopMenuVisibility {
        if (this.getMenuVersion() == AccountMenuVersion.V2)
            return this.accountMenuV2Config.toggleSourceItem.indexOf(sourceitem) > -1 ? TopMenuVisibility.Never : TopMenuVisibility.Always;
        const value = this.accountMenuV2Config.v3ToggleSourceItem[sourceitem as keyof typeof this.accountMenuV2Config.v3ToggleSourceItem];
        if (value && typeof value === 'string') {
            return TopMenuVisibility[value as keyof typeof TopMenuVisibility];
        }
        return TopMenuVisibility.Always;
    }

    isNewAccountMenu(): boolean {
        return (
            this.commonClientConfig.version == AccountMenuVersion.V2 ||
            this.commonClientConfig.version == AccountMenuVersion.V3 ||
            this.commonClientConfig.version == AccountMenuVersion.V4 ||
            this.commonClientConfig.version == AccountMenuVersion.V5
        );
    }

    getMenuVersion(): number {
        return this.commonClientConfig.version;
    }

    isEpcotMenuEnabled(): boolean {
        return this.commonClientConfig.version == AccountMenuVersion.V4;
    }

    addCardLayoutStyle(readyCheckRequired?: boolean) {
        if (readyCheckRequired) {
            this.accountMenuConfig.whenReady.subscribe(() => {
                this.appendCardLayoutClass(this.accountMenuConfig.account?.version);
                this.commonClientConfig.version = this.accountMenuConfig.account?.version;
            });
        } else {
            this.appendCardLayoutClass(this.commonClientConfig.version);
        }
    }

    appendCardLayoutClass(version: number) {
        if (version && version == AccountMenuVersion.V3) this.htmlNode.setCssClass('navigation-layout-page-card', true);
    }

    removeCardLayoutStyle() {
        if (this.commonClientConfig.version == AccountMenuVersion.V3) this.htmlNode.setCssClass('navigation-layout-page-card', false);
    }
    scrollToTop() {
        const el = document.querySelector('lh-navigation-layout #navigation-layout-content-container');
        if (el && document.contains(el) && this.isCustomerHubEnabled()) {
            // moves internal scroll to specific position
            el.scrollIntoView({ behavior: 'auto', block: 'start', inline: 'nearest' });
        }
        // moves windows scroll-bar to top
        this.window.nativeWindow.scrollTo(0, 0);
    }

    isCustomerHubEnabled(): boolean {
        return this.commonClientConfig.customerHubMenuVersions.indexOf(this.commonClientConfig.version) >= 0;
    }
}
